import React, { useState, useContext } from "react"
import { Modal } from "components/Core"
import { HiExclamation } from "react-icons/hi"
import { put_middleware_series_update } from "services/middleware_services"
import AuthContext from "store/context/PublicContext"
import Swal from "sweetalert2"

interface ConfirmStateChangeModalProps {
  isOpen: boolean
  onClose: () => void
  serieToUpdate: any
  newStateId: number
  newStateLabel: string
  onSuccess: () => void
}

const ConfirmStateChangeModal = ({
  isOpen,
  onClose,
  serieToUpdate,
  newStateId,
  newStateLabel,
  onSuccess,
}: ConfirmStateChangeModalProps) => {
  const [loading, setLoading] = useState(false)
  const { user } = useContext(AuthContext) as any

  const handleConfirm = async () => {
    if (!serieToUpdate) return
    
    setLoading(true)
    try {
      const entityId = serieToUpdate.id || serieToUpdate._id || ""
      const payload = { 
        estadoOmnix: newStateLabel.toLowerCase(),
        serieSap: serieToUpdate.serieSap
      }

      const response = await put_middleware_series_update(
        entityId,
        payload,
        user?.token,
        user?.email || user?.username,
        "frontend-xmonitor"
      )

      if (response.status >= 200 && response.status < 300) {
        onSuccess()
      } else {
        throw new Error("Respuesta no satisfactoria del servidor")
      }
    } catch (error: any) {
      console.error(error)
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || "No se pudo actualizar el estado de la serie.",
        icon: "error",
        confirmButtonColor: "#EF4444",
      })
    } finally {
      setLoading(false)
    }
  }

  if (!serieToUpdate) return null

  return (
    <Modal mounted={isOpen} className="!w-[480px] !max-w-[95vw] shadow-2xl border border-gray-100 rounded-2xl overflow-hidden">
      <div className="bg-white flex flex-col items-center p-6 text-center">
        <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
          <HiExclamation className="text-3xl text-blue-500" />
        </div>
        
        <h3 className="text-xl font-bold text-gray-800 mb-2">Confirmar cambio de estado</h3>
        <p className="text-gray-500 mb-6 text-sm">
          ¿Estás seguro de que deseas cambiar el estado de la serie <br/>
          <span className="font-bold text-gray-700">{serieToUpdate.serieSap}</span> a <span className="font-bold text-blue-600">"{newStateLabel}"</span>?
        </p>

        <div className="flex w-full gap-3 mt-2">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 py-2.5 px-4 rounded-xl font-bold bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl font-bold bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-70 shadow-lg shadow-blue-500/30"
          >
            {loading ? (
              <span className="h-5 w-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
            ) : "Sí, actualizar"}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmStateChangeModal
